import type { EntryPointComponent } from 'react-relay';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskProformaJiraFormBuilderRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskProformaJiraFormBuilderRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { Route } from '@atlassian/react-resource-router';
import ProformaJiraFormBuilder, {
	LazyProjectSettingsProformaJiraFormBuilder,
} from './ui/proforma-jira-form-builder/index.tsx';

const projectSettingsServicedeskProformaJiraFormBuilderPageEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-project-settings-proforma-jira-form-builder", jiraSpaEntry: "async-project-settings-proforma-jira-form-builder" */ '@jira/spa-apps__project-settings-proforma-jira-form-builder/src/ProformaJiraFormBuilderPage.tsx',
			{ entryFsSsrLiftImportToModule: false },
		),
		getPreloadProps: () => ({}),
	},
});

export const projectSettingsServicedeskProformaJiraFormBuilderRouteEntry: Route = createEntry(
	projectSettingsServicedeskProformaJiraFormBuilderRoute,
	() => ({
		group: 'project-settings-servicedesk',

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_2') ? undefined : ProformaJiraFormBuilder,

		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_2')
				? projectSettingsServicedeskProformaJiraFormBuilderPageEntryPoint
				: undefined,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsProformaJiraFormBuilder],
		perfMetricKey: 'form-builder',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
